import React from 'react';
import { Form } from 'react-bootstrap';

const TextAreaInput = ({ label, name, placeholder, rows = 4, register, errors, rules, readOnly, userRoles }) => {
  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label className="mb-1">{label}</Form.Label>
      <Form.Control
        as="textarea"
        placeholder={placeholder}
        rows={rows}
        style={{ resize: 'none' }}
        {...register(name, rules)}
        isInvalid={!!errors?.[name]}
        readOnly={readOnly || userRoles}
        autoComplete='off'
      />
      {errors?.[name] && (
        <Form.Control.Feedback type="invalid">
          {errors[name].message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default TextAreaInput;